import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	missingToken: {
		id: 'issue-create.common.fields.attachments-field.missing-token',
		defaultMessage: 'Something went wrong',
		description: 'Error message when token is missing',
	},
	attachmentSizeLimitCheck: {
		id: 'issue-create.common.fields.attachments-field.attachment-size-limit-check',
		defaultMessage: 'We couldn’t upload the attachment as you’ve exceeded the limit',
		description: 'Error message when a total file attachment size limit is crossed',
	},
});
